/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLatestCommit.defs.js'
export { main as default } from './getLatestCommit.defs.js'
